import renderer from "_src/engine/renderer";
import Scene from "_src/engine/scene";
import Camera from "_src/engine/camera";
import bufferFactory from "_src/engine/factories/pixel_buffer";
import FrameBuffer from "_src/engine/framebuffer";
import { pixelBufferType, primitiveType, cameraType } from "_src/engine/constants";
import DefaultShader from "_src/shaders/default/default_shader";
import objFactory from "_src/engine/factories/object";
import primitiveFactory from "_src/engine/factories/primitive";
import {colorType} from "_src/constants";

export default {

  apply(texture, hue, saturation, brightness, contrast, gamma) {

    const scene = new Scene();
    const camera = new Camera();
    scene.appendCamera(camera);

    camera.setTranslation(0, 0, 1);

    camera.setType(cameraType.ORTHO);
    camera.setViewport(texture.width, texture.height);

    const colorAttachment = bufferFactory.create(pixelBufferType.T_RGBA,
        { width : texture.width, height : texture.height });
    scene.setFramebuffer(new FrameBuffer([colorAttachment], null));

    const shader = new DefaultShader({lighting : false});
    shader.setDirective("COLOR_TYPE", colorType.TEXTURE_UV);

    const plane = objFactory.createDrawable(shader);
    plane.addGeometryChunk(primitiveFactory.create(primitiveType.PLANE, {width : 2, height : 2}));
    plane.setTexture(texture, 0);

    scene.add(plane);

    shader.setTextureAdjustmentEnabled(true);
    shader.setTextureHue(hue);
    shader.setTextureSaturation(saturation);
    shader.setTextureBrightness(brightness);
    shader.setTextureContrast(contrast);
    shader.setTextureGamma(gamma);

    const promise = scene.getBufferPixels().then((pixels) => {

      texture.flipY = true;
      texture.initMipMapLevelBuffer(0, pixels);

      return true;

    });

    renderer.renderScene(scene, true);

    return promise;

  }

}
